import React from "react";
import "./info-panel.scss";

export interface InfoPanelProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "children" | "title"> {
  /** Bold heading displayed at the top of the panel. */
  title: string;
  /** Width of the panel (CSS value or number in px). */
  width?: string | number;
  /** Fixed width for every label column inside the panel (CSS value or number in px). */
  labelWidth?: string | number;
  /** Custom border color for the card. */
  borderColor?: string;
  /** Body content — typically LabeledValue components in horizontal direction. */
  children?: React.ReactNode;
  /** Additional CSS class for the root element. */
  className?: string;
}

export const InfoPanel: React.FC<InfoPanelProps> = ({
  title,
  width,
  labelWidth,
  borderColor,
  children,
  className = "",
  style,
  ...rest
}) => {
  const cls = "info-panel";

  const rootClass = [cls, className].filter(Boolean).join(" ");

  const rootStyle: React.CSSProperties = {
    ...(width != null
      ? { width: typeof width === "number" ? `${width}px` : width }
      : {}),
    ...(labelWidth != null
      ? {
          "--info-panel-label-width":
            typeof labelWidth === "number" ? `${labelWidth}px` : labelWidth,
        }
      : {}),
    ...(borderColor ? { borderColor } : {}),
    ...style,
  } as React.CSSProperties;

  const hasStyle = Object.keys(rootStyle).length > 0;

  return (
    <div
      className={rootClass}
      style={hasStyle ? rootStyle : undefined}
      {...rest}
    >
      <h4 className={`${cls}__title`}>{title}</h4>
      {children != null && (
        <div className={`${cls}__body`}>{children}</div>
      )}
    </div>
  );
};

export default InfoPanel;
